import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import history from '../../../history'

import GenericRow from '../../../GenericComponents/GenericRow'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericButton from '../../../GenericComponents/GenericButton'
import { LandingSocialContainer, LandingSocial } from '../style/LandingStyle'
import { FaFacebookF } from 'react-icons/fa'
import { BsInstagram } from 'react-icons/bs'

interface TopNavbarInterface {}

const TopNavbar: FC<TopNavbarInterface> = ({}) => {
  const pushToLogin = () => {
    history.push('/zaloguj')
  }

  return (
    <GenericRow
      justify="space-between"
      className="landing"
      padding={isMobile ? '1.25rem 4%' : '1.25rem 20%'}
    >
      <GenericLogo
        width={isMobile ? '38vw' : '13vw'}
        height={isMobile ? '8vh' : '7vh'}
      />
      <LandingSocialContainer>
        <a
          href="https://www.facebook.com/fitmatkawariatka/"
          target="_blank"
          rel="noreferer"
        >
          <LandingSocial className="fb">
            <FaFacebookF />
          </LandingSocial>
        </a>
        <a
          href="https://www.instagram.com/fitmatkawariatka/"
          target="_blank"
          rel="noreferer"
        >
          <LandingSocial className="insta">
            <BsInstagram />
          </LandingSocial>
        </a>
      </LandingSocialContainer>
      <GenericButton
        onClick={pushToLogin}
        justify="center"
        tAlign="center"
        padding="15px 50px"
        borderRadius={'30px'}
        margin={isMobile ? '0 10% 0 0' : ''}
        className="promo-outline-btn"
        width={isMobile ? '30%' : 'max-content'}
      >
        {' '}
        <span className="button-span">Zaloguj </span>
      </GenericButton>
    </GenericRow>
  )
}

export default TopNavbar
